import { useQuery } from '@tanstack/react-query';
import { getPatientsByClinicalSite } from '../services/clinical_sites';

const usePatientsByClinicalSite = (clinicalSiteId) => {
    const getPatientsQuery = useQuery({
        queryKey: ['patientsByClinicalSite', clinicalSiteId],
        queryFn: () => getPatientsByClinicalSite(clinicalSiteId),
        enabled: Boolean(clinicalSiteId)
    });
    return getPatientsQuery;
}

export default usePatientsByClinicalSite; 